import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

    @Input() max = 100;
    @Input() progress = 0;
    @HostBinding('style.height.px') @Input() barHeight = 6;

    get barWidth() {
        return this.percent(this.progress, this.max)
    }

    constructor() {
    }

    ngOnInit(): void {
    }

    percent(a, b) {
        return  100 * a / (a + b);
    }

}
